import { isBEPriceCalculationEnabled } from "~/utils/features";
import * as ApiHelper from "../api/ApiHelper";
import { type AddToCartApiItem, DEPRECATED_ATTRIBUTES_TO_REMOVE } from "~/feature/cart/cart/api/AddToCart";
import { resolveApiUrl } from "../utils/url/urlResolver";

const apiUrl = resolveApiUrl("/quote/list/checkout");

export function sendDataMultipleQuotes(data: { quoteNumber: string; items: AddToCartApiItem[] }[]) {
  if (isBEPriceCalculationEnabled()) {
    DEPRECATED_ATTRIBUTES_TO_REMOVE.forEach((attr) => {
      data.forEach((quote) => {
        quote.items.forEach((item) => {
          // @ts-expect-error - This code will be removed in two releases
          delete item[attr];
          item.optionalParts?.forEach((part) => {
            // @ts-expect-error - This code will be removed in two releases
            delete part[attr];
          });
        });
      });
    });
  }

  const packageToCartForm = JSON.stringify(data);

  return fetch(apiUrl, {
    body: packageToCartForm,
    cache: "no-cache",
    credentials: "same-origin",
    method: "POST",
    mode: "cors",
    headers: {
      dataType: "json",
      "content-type": "application/json",
      CSRFToken: ApiHelper.getCsrfValue(),
    },
    redirect: "follow",
  })
    .then((result) => {
      window.SCHA.updateMinicart?.();
      return result;
    })
    .then((result) => {
      return result;
    });
}
